/**
 * BoardConfigDisplay Component
 * Displays the current snakes and ladders configuration below the board
 */

import { formatConfigForDisplay } from './boardConfig';

export const BoardConfigDisplay = ({ config }) => {
    const { snakes, ladders } = formatConfigForDisplay(config);

    return (
        <div className="mt-4 text-sm text-gray-600 space-y-1">
            <div>
                <span className="font-medium text-badger-purple">Snakes:</span>{' '}
                <span>{snakes || 'None'}</span>
            </div>
            <div>
                <span className="font-medium text-yellow-600">Ladders:</span>{' '}
                <span>{ladders || 'None'}</span>
            </div>
        </div>
    );
};

export default BoardConfigDisplay;
